import { render, staticRenderFns } from "./welcome-admin-modal.vue?vue&type=template&id=8a1dcabe&scoped=true"
import script from "./welcome-admin-modal.vue?vue&type=script&lang=js"
export * from "./welcome-admin-modal.vue?vue&type=script&lang=js"
import style0 from "./welcome-admin-modal.vue?vue&type=style&index=0&id=8a1dcabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1dcabe",
  null
  
)

export default component.exports